import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { api } from '../api/client';
import { LogoFull } from '../components/Logo';

export default function ResendVerification() {
  const location = useLocation();
  const prefill = new URLSearchParams(location.search).get('email') || '';
  const [email, setEmail] = useState(prefill);
  const [sent, setSent] = useState(false);
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await api.auth.resendVerification(email);
      setSent(true);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-card" style={{ textAlign: 'center' }}>
        <div className="auth-logo"><LogoFull iconSize={64} /></div>

        {sent ? (
          <>
            <div style={{ fontSize: 48, margin: '16px 0' }}>&#9993;</div>
            <h1 className="auth-title">Email sent</h1>
            <p style={{ color: 'var(--muted)', fontSize: 15, lineHeight: 1.7, marginBottom: 24 }}>
              If <strong style={{ color: 'var(--text)' }}>{email}</strong> is registered and unverified,
              a new link has been sent. Check your inbox.
            </p>
            <Link to="/login" style={{ color: 'var(--accent)', fontSize: 14 }}>Back to sign in</Link>
          </>
        ) : (
          <>
            <h1 className="auth-title">Resend verification</h1>
            <p style={{ color: 'var(--muted)', fontSize: 14, marginBottom: 24 }}>
              Enter your email and we'll send a new verification link.
            </p>
            {error && <div className="alert alert-error">{error}</div>}
            <form onSubmit={handleSubmit} style={{ textAlign: 'left' }}>
              <div className="form-group">
                <label>Email address</label>
                <input type="email" value={email} onChange={e => setEmail(e.target.value)}
                  placeholder="you@example.com" required autoComplete="email" />
              </div>
              <button type="submit" className="btn btn-primary" disabled={loading}>
                {loading ? <><span className="spinner"></span> Sending...</> : 'Send verification link'}
              </button>
            </form>
            <p className="auth-link-text" style={{ marginTop: 20 }}>
              <Link to="/login" style={{ color: 'var(--muted)', fontSize: 13 }}>Back to sign in</Link>
            </p>
          </>
        )}
      </div>
    </div>
  );
}
